package com.anjuros.website.templates.template2.styles

import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flex
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.scaleX
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba

val CompanyColorVar by StyleVariable<CSSColorValue>()

val Template2NavigationItemStyle = CssStyle {
    cssRule(" > #sectionUnderline"){
        Modifier .opacity(0.0)
            .transition(Transition.of(property = "opacity", duration = 200.ms))
    }
    cssRule(":hover > #sectionUnderline"){
        Modifier .opacity(1.0)
    }
}

val Template2MainTextStyle = CssStyle {

    base {
        Modifier
            .scale(1.0)
            .transition(Transition.of(property = "scale", duration = 200.ms))
    }
    hover {
        Modifier
            .scale(1.2)
    }
}
val Template2ContactTextStyle = CssStyle {

    base {
        Modifier
            .scale(1.0)
            .transition(Transition.of(property = "scale", duration = 200.ms))
    }
    hover {
        Modifier
            .scale(1.1)
    }
}

val Template2MenuWidthStyle = CssStyle {
    base { Modifier.width(50.percent) }
    Breakpoint.MD {  Modifier.width(25.percent) }
    Breakpoint.LG {Modifier.width(25.percent) }
    Breakpoint.XL { Modifier.width(25.percent)}
}

val Template2NavigationHeaderItemStyle = CssStyle {
    base {
        Modifier
            .color(Template2Theme.Secondary.rgb)
            .transition(Transition.of(property = "color", duration = 200.ms))
    }
    hover {
        Modifier
            .color(CompanyColorVar.value())
    }
}

val Template2HeaderLogoStyle = CssStyle {
    base { Modifier.padding(left=0.px, bottom=20.px, top=20.px, right=0.px) }
    Breakpoint.MD {  Modifier.padding(left=0.px, bottom=20.px, top=20.px, right=0.px) }
    Breakpoint.LG {Modifier.padding(left=30.px, bottom=20.px, top=20.px, right=0.px) }
    Breakpoint.XL { Modifier.padding(left=30.px, bottom=20.px, top=20.px, right=0.px)}
}

val ReviewArrowStyle = CssStyle {
    base {
        Modifier
            .color(Template2Theme.Gray.rgb)
            .transition(Transition.of("color", 200.ms))
    }
    hover {
        Modifier
            .color(CompanyColorVar.value())
    }
}

val ReviewCardMaxWidthStyle = CssStyle {

    base {
        Modifier.maxWidth(340.px)
    }

    Breakpoint.MD {
        Modifier.maxWidth(645.px)
    }

    Breakpoint.LG {
        Modifier.maxWidth(1120.px)
    }

    Breakpoint.XL {
        Modifier.maxWidth(1120.px)
    }
}

val ReviewSingleCardWidthStyle = CssStyle {

    base {
        Modifier
            .width(250.px)
            .flexShrink(0)
    }

    Breakpoint.MD {
        Modifier
            .width(300.px)
            .flexShrink(0)
    }

    Breakpoint.LG {
        Modifier
            .width(350.px)
            .flexShrink(0)
    }

    Breakpoint.XL {
        Modifier
            .width(350.px)
            .flexShrink(0)
    }
}

val Template2FooterMarginStyle = CssStyle {
    base { Modifier.margin(topBottom = 20.px) }
    Breakpoint.MD { Modifier.margin(topBottom = 0.px) }
    Breakpoint.LG { Modifier.margin(topBottom = 0.px) }
    Breakpoint.XL { Modifier.margin(topBottom = 0.px)}
}

val Template2ServiceCardStyle = CssStyle {

    base {
        Modifier
            .translateY(0.px)
            .boxShadow(
                offsetY = 12.px,
                blurRadius = 30.px,
                color = rgba(0, 0, 0, .3)
            )
            .transition(
                Transition.of("boxShadow", 300.ms),
                Transition.of("translateY", 300.ms)
            )
    }

    hover {
        Modifier
            .translateY((-4).px)
            .boxShadow(
                offsetY = 22.px,
                blurRadius = 45.px,
                color = rgba(0, 0, 0, .4)
            )
    }
}

val Template2ReasonCardStyle = CssStyle {

    base {
        Modifier

            .backgroundColor(Colors.White)
            .borderRadius(18.px)
            .border(
                width = 1.px,
                style = LineStyle.Solid,
                color = rgb(239,239,239)
            )
            .boxShadow(
                offsetY = 6.px,
                blurRadius = 18.px,
                color = rgba(0,0,0,.05)
            )
            .transition(
                Transition.of(
                    TransitionProperty.All,
                    220.ms
                )
            )
    }

    hover {
        Modifier
            .translateY((-5).px)
            .border(
                width = 1.px,
                style = LineStyle.Solid,
                color = Theme.Secondary.rgb
            )
            .boxShadow(
                offsetY = 18.px,
                blurRadius = 42.px,
                color = rgba(0,0,0,.12)
            )
    }

}

val Template2HeroTitleStyle = CssStyle {
    base { Modifier.fontSize(34.px) }
    Breakpoint.MD { Modifier.fontSize(48.px) }
    Breakpoint.LG { Modifier.fontSize(64.px) }
    Breakpoint.XL { Modifier.fontSize(64.px)}
}

val Template2HeroColumnStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent).margin(top = 20.px).padding(leftRight=20.px) }
    Breakpoint.MD { Modifier.fillMaxWidth(90.percent).margin(top = 20.px).padding(leftRight=20.px) }
    Breakpoint.LG { Modifier.flex(1) .padding(left = 60.px) }
    Breakpoint.XL { Modifier.flex(1) .padding(left = 60.px)}
}

val Template2SectionTitleStyle = CssStyle {
    base { Modifier.fontSize(28.px) }
    Breakpoint.MD { Modifier.fontSize(34.px) }
    Breakpoint.LG { Modifier.fontSize(40.px) }
    Breakpoint.XL { Modifier.fontSize(40.px)}
}
val Template2SectionSubTitleStyle = CssStyle {
    base { Modifier.fillMaxWidth() }
    Breakpoint.MD { Modifier.maxWidth(700.px) }
    Breakpoint.LG { Modifier.maxWidth(700.px) }
    Breakpoint.XL { Modifier.maxWidth(700.px)}
}

val Template2ServiceColumnStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(70.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(70.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(70.percent)}
}

val Template2AchievementsStyle = CssStyle {
    base { Modifier.fontSize(24.px) }
    Breakpoint.MD { Modifier.fontSize(30.px) }
    Breakpoint.LG { Modifier.fontSize(36.px) }
    Breakpoint.XL { Modifier.fontSize(36.px)}
}

val Template2ReasonColumnStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier.flex(1) }
    Breakpoint.LG { Modifier.flex(1) }
    Breakpoint.XL { Modifier.flex(1)}
}

val Template2ContactBoxStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(80.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(70.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(70.percent)}
}

val Template2ContactCardWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(100.percent).margin(bottom = 20.px) }
    Breakpoint.MD { Modifier.fillMaxWidth(100.percent).margin(bottom = 20.px) }
    Breakpoint.LG { Modifier.width(400.px)}
    Breakpoint.XL { Modifier.width(400.px)}
}

val Template2ContactBuilderStyle = CssStyle {
    base { Modifier.fillMaxWidth(80.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(70.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(40.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(40.percent)}
}
